import React from "react";
import styles from "../../../pages/creditsListing/CreditsListing.module.scss";
import Marquee from "react-fast-marquee";
import { EntryIcon, FailedEntryIcon, SuccessEntryIcon } from "customIcons";
import { Skeleton } from "@mui/material";

export interface ExcelUploadSummaryProps {
  fileName: string;
  totalEntries: number | string;
  successEntries: number | string;
  errorEntries: number | string;
  title?: string;
  currency?: string;
  totalCreditValue?: number | string;
  loading?: boolean;
}

const ExcelUploadSummary: React.FC<ExcelUploadSummaryProps> = ({
  fileName,
  totalEntries,
  successEntries,
  errorEntries,
  title = "Excel Upload Summary",
  currency,
  totalCreditValue,
  loading = false,
}) => {
  /* --------------------------------------------------------------------------
   * Render
   * -------------------------------------------------------------------------- */
  return (
    <div className={styles["excel-upload__header"]}>
      {/* Summary Title */}
      <h3>{title}</h3>

      <div className={styles["excel-upload__body"]}>
        {/* Left Section: File Name */}
        <div className={styles["excel-upload__body-left"]}>
          <span>File Name</span>
          {loading ? (
            <Skeleton variant="text" width={180} />
          ) : (
            <p className={styles["excel-upload__file-name"]}>
              <Marquee
                gradient={false}
                speed={40}
                pauseOnHover
                play={fileName?.length > 40}
              >
                {fileName} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Marquee>
            </p>
          )}
        </div>

        {/* Right Section: Statistics Grid */}
        <div className={styles["excel-upload__body-right"]}>
          {/* Total Entries */}
          <div className={styles["excel-upload__body-item"]}>
            <span className={styles["excel-upload__body--entry"]}>
              {loading ? (
                <Skeleton variant="circular" width={32} height={32} />
              ) : (
                <EntryIcon />
              )}
            </span>
            <div>
              <span className={styles["count-text"]}>
                {loading ? (
                  <Skeleton variant="text" width={40} />
                ) : (
                  totalEntries
                )}
              </span>
              <p>Total Entries</p>
            </div>
          </div>

          {/* Successful Entries - Green success icon */}
          <div className={styles["excel-upload__body-item"]}>
            <span className={styles["excel-upload__body--success"]}>
              {loading ? (
                <Skeleton variant="circular" width={32} height={32} />
              ) : (
                <SuccessEntryIcon />
              )}
            </span>
            <div>
              <span className={styles["count-text"]}>
                {loading ? (
                  <Skeleton variant="text" width={40} />
                ) : (
                  successEntries
                )}
              </span>
              <p>Successful Entries</p>
            </div>
          </div>

          {/* Error Entries - Red error icon */}
          <div className={styles["excel-upload__body-item"]}>
            <span className={styles["excel-upload__body--error"]}>
              {loading ? (
                <Skeleton variant="circular" width={32} height={32} />
              ) : (
                <FailedEntryIcon />
              )}
            </span>
            <div>
              <span className={styles["count-text"]}>
                {loading ? (
                  <Skeleton variant="text" width={40} />
                ) : (
                  errorEntries
                )}
              </span>
              <p>Error Entries</p>
            </div>
          </div>

          {/* Total Credit Value - Currency and amount */}
          <div className={styles["excel-upload__body-item"]}>
            <div>
              <span className={styles["count-text"]}>
                {loading ? (
                  <Skeleton variant="text" width={80} />
                ) : (
                  <>
                    {currency} {totalCreditValue}
                  </>
                )}
              </span>
              <p>Total Credit Value</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcelUploadSummary;
